import { render } from "./EditorialFlairImage.vue?vue&type=template&id=96039f94&scoped=true"
import script from "./EditorialFlairImage.vue?vue&type=script&lang=js"
export * from "./EditorialFlairImage.vue?vue&type=script&lang=js"

import "./EditorialFlairImage.vue?vue&type=style&index=0&id=96039f94&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96039f94"]])

export default __exports__